import {
  Toast
} from 'vant'
// 客户端交互方法
if (!window.JSBridge) {
  window.JSBridge = {}
  JSBridge.onUploadMedicalRecord = function(token) {
    console.log('JSBridge.onUploadMedicalRecord token ' + token)
  }
  JSBridge.signBase64 = function(base64) {
    console.log('手写签名图片base64', base64)
  }
}
